export const EmploymentReadinessAssessmentSections: { [name: string]: string } = {
  identifiedNeeds: 'Identified needs',
  personalInfo: 'Personal info',
  dependents: 'Dependents',
  education: 'Education',
  employment: 'Employment',
  health: 'Health',
  disability: 'Disability',
};
